import jssVariables from "../../../jss_setup";

export const commonStylesBasic = {
  ...jssVariables.fontsStyles.normalText,
  minWidth: "max-content",
  minHeight: "max-content",
  height: "max-content",
  maxHeight: "max-content",
  borderRadius: jssVariables.half_gap,
  padding: `calc(${jssVariables.normal_gap} / 3) calc(${jssVariables.normal_gap} * 1)`,
  cursor: "pointer",
  transition: "color .3s, background .3s",
  background: jssVariables.colors.base_color,
  border: `1px solid ${jssVariables.colors.base_color}`,
  color: "white",
  // alignItems: "center",
  // alignContent: "center",
  // justifyContent: "space-between",
  gridGap: jssVariables.half_gap,
  width: "100%",
  "&:hover": {
    color: jssVariables.colors.base_color,
    background: "white",
  },
};

export function getCommonStylesLabelBasic(props) {
  return {
    fontFamily: jssVariables.fontFamily,
    lineHeight: "max-content",
    textTransform: "capitalize",
    fontWeight: props.bold ? "bold" : 500,
    fontSize: props.size ? props.size : "medium",
  };
}

export const commonStylesIconBasic = {
  marginBottom: ".15rem",
  fontSize: "medium",
};

export const commonStylesPlaceholderBasic = {
  minWidth: "6rem!important",
  height: "2.5rem!important",
  maxHeight: "2.5rem!important",
};

export const commonStylesPlaceholderSearchBtn = {
  height: "3rem !important",
  width: "10rem !important",
};

export const commonStylesPlaceholderMSFNavBtn = {
  height: "3rem !important",
  width: "10rem !important",
};
